import React, { useEffect, useState } from 'react'
import { platformApi } from '../../../../api'
import { Table, Divider, Popconfirm, Button, Typography, message } from "antd";
import moment from 'moment';

const CallerTemplate = ({getTemplates,templates,openModal}) => {

  useEffect(()=>{
    getTemplates();
  },[]);

  const deleteData = (id) => {
    try {
      platformApi.delete(`/api/autocall/${id}`).then((response) => {
        message.info(response.data.msg);
        getTemplates();
      });
    } catch (err) {
      message.error("Error occurred");
    }
  };
  

  const column = [
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      width:"11rem",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Submodule",
      dataIndex: "submodule",
      key: "submodule",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Audio",
      dataIndex: "audioUrl",
      key: "audio",
      render: (audioUrl) =>
        audioUrl ? (
          <audio controls>
            <source src={audioUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        ) : (
          "-"
        ),
    },    
    {
      title: "status",
      dataIndex: "status",
      key: "status",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => <span>{moment(new Date(record)).format('DD/MM/YYYY')}</span>,
    },
    {
      title: "Action",
      render: (data) => (
        <div>
            <span
              onClick={(event) => {
                event.stopPropagation();
                openModal(data.id, true);
              }}
              className="linkylink"
            >
              Modify
            </span>
    
            <Popconfirm
              title="Are you sure delete this Template?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(data.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
                <Divider type="vertical" />
                Delete
              </span>
            </Popconfirm>
        </div>
      ),
    },
  ];

  

  return (
    <Table
      rowKey={(record) => record.id}
      columns={column}
      dataSource={templates}
      style={{ cursor: "pointer" }}
      onRow={(props) => ({
        onClick: () => {
          openModal(props.id, false);
        },
      })}
    />
    
  )
}

export default CallerTemplate
